"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var axios_1 = __importDefault(require("axios"));
var react_datepicker_1 = __importDefault(require("react-datepicker"));
var api_1 = require("api");
var PrefsStore_1 = require("stores/PrefsStore");
var use_stores_1 = require("hooks/use-stores");
var close_icon_svg_1 = __importDefault(require("res/img/close-icon.svg"));
var calendar_icon_svg_1 = __importDefault(require("res/img/calendar-icon.svg"));
var left_icon_svg_1 = __importDefault(require("res/img/left-icon.svg"));
var right_icon_svg_1 = __importDefault(require("res/img/right-icon.svg"));
var DatePicker = mobx_react_1.observer(function (_a) {
    var label = _a.label, selected = _a.selected, onChange = _a.onChange, disabled = _a.disabled, disablePopup = _a.disablePopup;
    var prefsStore = use_stores_1.useStores().prefsStore;
    react_1.useEffect(function () {
        if (prefsStore.data.bankHolidays === null) {
            axios_1.default.get('https://www.gov.uk/bank-holidays.json')
                .then(function (response) {
                prefsStore.editData({
                    bankHolidays: response.data
                });
            })
                .catch(api_1.catchHandler);
        }
    }, []);
    var CustomInput = react_1.forwardRef(function (props, ref) { return (react_1.default.createElement("div", { className: 'date-picker__input flex flex-row flex-space-between' },
        react_1.default.createElement("button", { className: 'date-picker__value flex flex-row flex-space-between', onClick: disabled ? function () { } : props.onClick, ref: ref },
            react_1.default.createElement("span", null, (props.value && props.value.length >= 0) ? props.value : 'Select Date...'),
            react_1.default.createElement("img", { src: calendar_icon_svg_1.default, alt: 'Calendar' })),
        props.value &&
            react_1.default.createElement("button", { className: 'date-picker__clear flex flex-column flex-center', onClick: function () { return onChange(null); }, "aria-label": 'Clear date', title: 'Clear date' },
                react_1.default.createElement("img", { src: close_icon_svg_1.default, alt: 'Clear Date' })) ||
            react_1.default.createElement("div", { className: 'date-picker__spacer' }, "\u00A0"))); });
    var filterDate = function (date) {
        var bankHolidays = prefsStore.data.bankHolidays;
        var bhSetting = PrefsStore_1.BankHolidayDivisions.ENGLAND_AND_WALES;
        if (bankHolidays[bhSetting]) {
            for (var _i = 0, _a = bankHolidays[bhSetting].events; _i < _a.length; _i++) {
                var event_1 = _a[_i];
                var eventDate = new Date(event_1.date);
                if (eventDate.getFullYear() === date.getFullYear() &&
                    eventDate.getMonth() === date.getMonth() &&
                    eventDate.getDate() === date.getDate())
                    return false;
            }
        }
        var day = date.getDay();
        return day !== 0 && day !== 6;
    };
    var monthsArray = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    var CustomHeader = function (_a) {
        var date = _a.date, decreaseMonth = _a.decreaseMonth, increaseMonth = _a.increaseMonth;
        return (react_1.default.createElement("div", { className: 'date-picker__header flex flex-row' },
            react_1.default.createElement("button", { type: 'button', "aria-label": 'Previous Month', className: 'date-picker__button flex flex-column flex-center', onClick: decreaseMonth, title: 'Previous Month' },
                react_1.default.createElement("img", { src: left_icon_svg_1.default, alt: 'Previous' })),
            react_1.default.createElement("span", null,
                monthsArray[date.getMonth()],
                " ",
                date.getFullYear()),
            react_1.default.createElement("button", { type: 'button', "aria-label": 'Next Month', className: 'date-picker__button flex flex-column flex-center', onClick: increaseMonth, title: 'Next Month' },
                react_1.default.createElement("img", { src: right_icon_svg_1.default, alt: 'Next' }))));
    };
    var now = new Date();
    return (react_1.default.createElement("div", { className: 'input date-picker flex flex-row', title: disabled && disablePopup, "data-disabled": disabled },
        react_1.default.createElement("label", null, label),
        react_1.default.createElement(react_datepicker_1.default, { selected: selected, onChange: onChange, dateFormat: 'dd/MM/yyyy', customInput: react_1.default.createElement(CustomInput, null), renderCustomHeader: function (_a) {
                var date = _a.date, decreaseMonth = _a.decreaseMonth, increaseMonth = _a.increaseMonth;
                return (react_1.default.createElement(CustomHeader, { date: date, decreaseMonth: decreaseMonth, increaseMonth: increaseMonth }));
            }, filterDate: filterDate, calendarClassName: 'date-picker-calendar' })));
});
exports.default = DatePicker;
